import {
  nucleusConstants,
  accountSelectors
} from '@lifesize/nucleus';
import { createSelector } from 'reselect';

const oneTimeMeetingFeatureSelector = state => accountSelectors.getAccountFeature(state)(
  nucleusConstants.ACCOUNT_FEATURE_ONE_TIME_MEETING
);

const permanentMeetingsFeatureSelector = state => accountSelectors.getAccountFeature(state)('permanentMeeting');

const permanentMeetingsSettingSelector = state => accountSelectors.getAccountSettings(state)['allowPermanentMeetings'];

const requireMeetingPasscodeSelector = state => accountSelectors.getAccountSettings(state)['requireMeetingPasscode'];

const showPermanentMeetingsSelector = createSelector(
  permanentMeetingsFeatureSelector,
  permanentMeetingsSettingSelector,
  (hasPermanentMeetings, allowPermanentMeetings) => (
    hasPermanentMeetings && allowPermanentMeetings
  )
);

export default oneTimeMeetingFeatureSelector;

export {
  oneTimeMeetingFeatureSelector,
  permanentMeetingsFeatureSelector,
  permanentMeetingsSettingSelector,
  showPermanentMeetingsSelector,
  requireMeetingPasscodeSelector
};
